"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
exports.execMatch = ({ ast, execObject }, last) => {
    const value = Array.isArray(last) ? last.map((v) => v.value) : [last];
    const matchList = ast.toMatch[0].children.rules.map((expression) => {
        const conditions = getConditions({ ast: expression, execObject });
        const program = expression.children.rules[0];
        return {
            conditions,
            program,
        };
    });
    const m = matchList.find((expression) => lodash_1.default.isEqual(expression.conditions, value) || expression.conditions === null) || null;
    return m === null ? value : execObject.interpreter({ ast: m.program, execObject });
};
const getConditions = ({ ast, execObject }) => {
    if (ast.children.arguments !== undefined) {
        return ast.children.arguments.map((expression) => {
            return execObject.interpreter({
                ast: expression,
                execObject,
            });
        });
    }
    else {
        return null;
    }
};
